// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import Accounts from '@app/features/auth/state/Accounts';
import Authentication from '@app/features/auth/state/Authentication';
import {isFeedEnabled} from '@app/features/feed/utils/FeedUtils';
import Location from '@app/features/ui/state/Location';
import {useEffect} from 'react';

// Micup: the desktop window reopens the route it was last told; while the feed is on that is the DM home, so the window
// starts in the feed like the web app does.
export function getDesktopLastRoute(pathname: string): string {
	return isFeedEnabled() ? Routes.ME : pathname;
}

export function useLastLocationPersistence(pathname: string): void {
	const isAuthenticated = Authentication.isAuthenticated;
	const currentAccountKey = Accounts.currentAccountKey;
	const isViewLive = Accounts.isViewLive;
	useEffect(() => {
		if (!isAuthenticated || currentAccountKey === null || !isViewLive) {
			return;
		}
		if (!Routes.isChannelRoute(pathname) && !Routes.isSpecialPage(pathname)) {
			return;
		}
		Location.saveLocation(pathname);
		globalThis.window?.electron?.reportLastRoute?.(getDesktopLastRoute(pathname));
	}, [currentAccountKey, isAuthenticated, isViewLive, pathname]);
}
